export const HOME_PATH = '/';
export const AUTH_BASE_PATH = '/auth';
export const generateAuthPath = (type) =>
	`${AUTH_BASE_PATH}/${type}`;
export const AUTH_PATH = generateAuthPath(':type');

export const VERIFY_PATH = '/auth/verify/:token';
export const ADD_PAYMENT_METHOD = '/add-payment';
export const CONFIRMATION_CHANGE_EMAIL_PATH = '/confirm-email-change/:token';
export const JOIN_WITH_INVITATION = '/join/:token';
export const RESET_PASS_PATH = '/reset-password/:token';
export const EMAIL_CHANGE_VERIFY = '/email-change-verify/:token';
export const OAUTH_CALL_BACK = '/oauth/:type';
export const VERIFY_AUTH = '/verify/auth';
export const FACEBOOK_OAUTH_PATH = '/facebook/oauth';
export const INSTAGRAM_OAUTH_PATH = '/instagram/oauth';
export const TWITTER_OAUTH_PATH = '/twitter/oauth';
export const LINKEDIN_OAUTH_PATH = '/linkedin/oauth';
export const DISCUSSON_PATH = '/meeting/:id';
export const WEBINAR_PATH = '/webinar/:id';
export const RECORDING_JOIN = '/recording-room/join/:token';
export const NETPLA_PRICING = '/pricing';
export const ACCOUNT_PRICING = '/account/pricing';
export const SUBSCRIPTION='/subscription';
export const PRICING = '/user/pricing';
export const USER_PROFILE = '/user/profile';
export const USER_SETTING = '/user/settings';
export const USER_PAYMENT_METHODS = '/payment-methods';
export const USER_JOIN = '/user/join/:token';
export const JOIN_NOW = '/join-now';
export const USER_PUBLIC_ROOMS = '/user/rooms/public';
export const USER_PRIVATE_ROOMS = '/user/rooms/private';
export const USER_RECORDINGS = '/recordings/:roomId';
export const USERS = '/users';
export const USER_EDIT = '/user/:id/edit';
export const USER_CONTACT_US = '/user/contact-us';
export const PRIVACY_POLICY = '/privacy-policy';
export const TERMS_AND_CONDITION = '/terms-condition';

export const ADMIN_STATISTICS = '/admin/statistics';
export const ADMIN_PRICING = '/admin/pricing';
export const ADMIN_USERS = '/admin/users';
export const ADMIN_COMPANIES = '/admin/company';
export const ADMIN_SUBSCRIPTIONS = '/admin/subscriptions';
export const ADMIN_SUBSCRIPTION_HISTORY = '/admin/subscriptions/:customerId';
export const ADMIN_PARTICIPANTS = '/admin/participants';